
class VaultCloseController {
	/*@ngInject*/
	constructor(Auth, $state, User, Modal, DateUtil, $translate, $q, $scope, SetupService, BranchService, UsersService,
				BagoutService, $location, $rootScope, ShipmentService, DataCounter, Navigation, $window) {
		this.Modal = Modal;
		this.$translate = $translate;
		this.$q = $q;
		this.User = User;
		this.DateUtil = DateUtil;
		this.SetupService = SetupService;
		this.BranchService = BranchService;
		this.UsersService = UsersService;
		this.$scope = $scope;
		this.$state = $state;
		this.BagoutService = BagoutService;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.ShipmentService = ShipmentService;
		this.DataCounter = DataCounter;
		this.Navigation = Navigation;
		this.window = $window;
		this.allMsg = []
		this.userData = []
		this.usrData = []
		this.model = {
			branch: this.User.getUser().branchId,
			loggedInUser: this.User.getUser(),
			vaultDate: null,
			verifyErrors: [],
			searchText: "",
			errorMessageList: [],
			errorMessages: [],
			originLocationList: [],
			originLocations: [],
			destinationLocationList: [],
			destinationLocations: []
		};
		this.loading = false;
		this.showReset = false;
		this.$rootScope.$broadcast('routeChange', '/app/vault-close');
		this.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	}

	getUserData() {
		this.UsersService.get(this.model.loggedInUser.id)
			.then((data) => {
				this.userData = data
			})
	}

	// REMOVE data from Table
	truncateAllData() {
		this.BranchService.truncateRoute(this.model.branch)
			.then((data) => {
			}).catch((err) => {
				console.log(err);
			});
	}
	verifyCloseVault() {
		if (this.loading) return;
		this.loading = true;
		this.BranchService.verifyCloseVault(this.model.branch, this.model.loggedInUser.id, moment.tz.guess())
			.then((res) => {
				if (res && res.result && res.result.length) {
					let message = this.$translate.instant('closeVault.verify_vault_close_message', {
						date1: this.model.vaultDate,
						date2: moment(this.model.vaultDate).add(1, 'day').format('YYYY-MM-DD'),
					  })
					this.Modal.confirm({
						header: this.$translate.instant('closeVault.verify_vault_close_title'),
						message,
						callback: ({
							modal,
							$scope
						}) => {
							modal.close()
							this.closeVault()
						},
						negative: ({
							modal,
							$scope
						}) => {
							modal.close()
							this.loading = false;
						},
						type: 'primary',
						buttons: ['common.confirm_title', 'common.cancel']
					})
				} else {
					this.closeVault()
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					let msg = err.data.message;
					this.Modal.errorModal(msg);
				}
				this.loading = false;
				console.error(err);
			})
	}

	closeVault() {
		this.loading = true;
		this.BranchService.closeVault(this.model.branch, this.model.loggedInUser.id, this.model.vaultDate)
			.then(() => {
				//show message
				return this.loadCurrentVaultDate()
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					let msg = err.data.message;
					if (msg.includes('bank report(s) failed to be published.')) {
						this.formatString(msg, 40, '</br>');
					}
					else {
						this.Modal.errorModal(msg);
					}
				}
				console.error(err);
			})
			.finally(() => {
				this.loading = false;
			});
	}

	loadCurrentVaultDate() {
		return this.SetupService.get(this.model.branch)
			.then((setup) => {
				if (setup && setup.currentVaultDate) {
					this.model.vaultDate = this.DateUtil.getUTCDate(setup.currentVaultDate);
				}
			})
			.then(() => {
				this.verifyVaultClose(this.model.vaultDate)
					.then(() => {
						this.uniqueErrorMessages();
						this.uniqueOriginLocations();
						this.uniqueDestinationLocations();
					})
			})
			.catch((err) => {
				this.error = err.message
			});
	}

	verifyVaultClose(vaultDate) {
		this.model.loading = true;
		this.model.isError = false;
		return this.BranchService.verifyVault(this.model.branch, vaultDate)
			.then((data) => {
				this.model.verifyErrors = data;
				this.bagOutError = this.$translate.instant('closeVault.BAGOUT_NOT_CLOSED')
				data.forEach(element => {
					element.translateMessage = this.$translate.instant('closeVault.' + element.message)
					element.message = element.message
				});
				this.model.isError = false;
			})
			.catch((err) => {
				this.model.isError = true;
				if (err && err.data && err.data.message) {
					this.Modal.errorModal('error.' + err.data.message);
				}
			})
			.finally(() => {
				this.model.loading = false;
			})
	}

	// redirect to bagout close screen
	bagOutClose(bagoutId) {
		if (bagoutId) {
			this.$rootScope.$broadcast('routeChange', null);
			return this.BagoutService.getShipments(bagoutId)
				.then((res) => {
					this.$location.url('/app/bag-out-print?bagout=' + bagoutId);
				})
		}
	}

	$onInit() {
		this.$q.all([
			this.loadCurrentVaultDate(),
			this.getUserData()
		])
			.then((data) => {
				// console.log(data)
			})
			.catch((err) => {
				console.log(err);
			});
	}

	redirectTo(data) {
		this.$rootScope.$broadcast('routeChange', null);
		if (data.message === 'DELIVERY_NOT_PACKED') return this.$state.go('orderPacking');
		else if (data.message === 'DELIVERY_NOT_THROWN') return this.$state.go('routeThrow');
		else if (data.message === 'DELIVERY_NOT_CHECKED_OUT') return this.$state.go('checkout');
		else if (data.message === 'DELIVERY_NOT_DELIVERED') return this.$state.go('checkin');
		else if (data.message === 'PICKUP_NOT_CHECKED_IN') return this.$state.go('checkin');
		else if (data.message === 'PICKUP_NOT_BAGGED_OUT' || data.message === 'SHIPMENT_NOT_BAGGED_OUT') return this.$state.go('checkout');
		else if (data.message === 'HOLD_NOT_VERIFIED') return this.$state.go('branchManagement.itemHolds');
		else if (data.message === 'BAGOUT_NOT_CLOSED') return this.bagOutClose(data.trackingId);
		else if (data.message === 'BULK_TRANSFER_NOT_CLOSED') {
			return this.window.open(
				'/v2/index.html#/bulk-transfer/active?trackingId=' + encodeURIComponent(data.trackingId || ''),
				'_self'
			);
		}
		else if (data.message === 'DEPOSIT_NOT_RELEASED') return this.$state.go('depositPacking');
		else if (data.message === 'CRV_NOT_COUNTED') {
			const obj = {
				trackingId: data.trackingId,
				isRedirected: true,
				fundingSourceId: null,
				destinationLocationId: data.destinationLocationId
			}
			this.DataCounter.setData(obj);
			this.$state.go('atmCount');
		}
		else if (data.message === 'RESIDUAL_NOT_APPROVED') return this.goToFinalResidualCount(data);
		else if (data.message === 'BALANCECHECK_MISSING' || data.message === 'BALANCE_CHECK_VARIANCE') return this.goToPhysicalCashCount(data);
		else if (data.message === 'BULK_DEPOSIT_COUNT_NOT_COMPLETED') {
			const obj = {
				trackingId: data.trackingId,
				isRedirected: true,
				fundingSourceId: null,
				destinationLocationId: data.destinationLocationId
			}
			this.DataCounter.setData(obj);
			this.$state.go('atmCount');
		}
	}

	moveShipments(data) {
		this.Modal.moveShipmentModal(data, this.model.branch, ({ modal, toRoute, date, supervisorId }) => {
			let comment = this.bagRouteThrowError = this.$translate.instant('closeVault.shipment_moved', {
				fromRouteId: data.routeId,
				toRouteId: toRoute.Value
			})
			this.ShipmentService.holdRelease(data.trackingId, data.routeId, toRoute.Value, date, supervisorId, comment, this.model.branch)
				.then((data) => {
					modal.close();
					this.verifyVaultClose(this.model.vaultDate);
				})
				.catch((err) => {
					modal.close();
					if (err && err.data && err.data.message) {
						return this.Modal.errorModal('error.' + err.data.message);
					}
				})
		}, ({ modal }) => {
			modal.close();
		})
	}

	sendToHold(data) {
		let reason = '',
			comments = 'send to hold';

		const defer = this.$q.defer();
		this.Modal.confirmSupervisor('send-to-hold', ({ modal, supId }) => {
			this.ShipmentService.holdShipment(data.branchId, data.trackingId, data.routeId, data.vaultDate, supId, reason, comments)
				.then(() => {
					modal.close();
					defer.resolve();
				})
				.catch((err) => {
					modal.close();
					if (err && err.data && err.data.message) {
						return this.Modal.errorModal("error." + err.data.message);
					}
					defer.reject();
				})
		}, ({ modal }) => {
			modal.close();
		})
		defer.promise.then(() => {
			return this.verifyVaultClose(this.model.vaultDate);
		})
	}

	redirectToServiceHistory(locationId) {
		this.$rootScope.$broadcast('routeChange', null);
		const obj = {
			locationId: locationId,
			isRedirected: true
		}
		this.DataCounter.setData(obj);
		this.$location.url('/app/branch-management/locations-history');
	}

	redirectToItemTab(trackingId) {
		this.$rootScope.$broadcast('routeChange', null);
		this.$state.go('branchManagement.items', {
			id: trackingId,
		});
	}

	uniqueErrorMessages() {
		const messageGroup = _.groupBy(this.model.verifyErrors, 'message');
		const keys = Object.keys(messageGroup);
		keys.map((data) => {
			let translateMessage = messageGroup[data][0].translateMessage;
			this.model.errorMessageList.push({ message: data, translateMessage: translateMessage, ticked: false })
		})
	}

	uniqueOriginLocations() {
		const originLocationGroup = _.groupBy(this.model.verifyErrors, 'originLocationId');
		const keys = Object.keys(originLocationGroup);
		keys.map((data) => {
			if (data !== 'null') {
				let originLocation = data.concat(" | ", originLocationGroup[data][0].originLocationName);
				this.model.originLocationList.push({ originLocationId: data, originLocation: originLocation, ticked: false })
			}
		})
	}

	uniqueDestinationLocations() {
		const destinationLocationGroup = _.groupBy(this.model.verifyErrors, 'destinationLocationId');
		const keys = Object.keys(destinationLocationGroup);
		keys.map((data) => {
			if (data !== 'null') {
				let destinationLocation = data.concat(" | ", destinationLocationGroup[data][0].destinationLocationName);
				this.model.destinationLocationList.push({ destinationLocationId: data, destinationLocation: destinationLocation, ticked: false })
			}
		})
	}

	filterData() {
		let errorMessages = this.model.errorMessages;
		let originLocations = this.model.originLocations;
		let trackingId = this.model.searchText;
		let destinationLocations = this.model.destinationLocations;

		return function (row) {

			function searchMessage() {
				if (errorMessages.length) return errorMessages.some(function (data) { return row['message'].indexOf(data.message) > -1 })
				else return row['message'].indexOf('') > -1;
			}

			function searchOriginLocation() {
				if (originLocations.length) return originLocations.some(function (loc) { return row['originLocationId'] && row['originLocationId'].indexOf(loc.originLocationId) > -1 })
				else return row;
			}

			function searchDestinationLocation() {
				if (destinationLocations.length) return destinationLocations.some(function (loc) { return row['destinationLocationId'] && row['destinationLocationId'].indexOf(loc.destinationLocationId) > -1 })
				else return row;
			}

			function searchTrackingId() {
				if (trackingId) return row['trackingId'] && row['trackingId'].toUpperCase().indexOf(trackingId.toUpperCase()) > -1
				else return row;
			}

			return searchMessage() &&
				searchTrackingId() &&
				searchOriginLocation() &&
				searchDestinationLocation()
		}
	};

	formatString(str, width, brk) {
		// console.log(str, width, brk);

		// brk = brk || 'n';
		// width = width || 75;

		// if (!str) { return str; }

		// var regex = '.{1,' + width + '}(\  |- )' + ('|.{' + width + '}|.+$');

		// let opt = str.match(RegExp(regex, 'g')).join(brk);
		// return this.Modal.errorModal(opt.toString().replace(/-/, '</br>').replace('-', '--'))

		var output = str.toString().replace(/-/, '<br><br>').replace(/1. Error/, '<br>');
		return this.Modal.errorModal(output.split(": ").join("1. Error: ").replace('-', '--'))
	}

	routeCheckIn(data) {
		const formattedDate = moment.utc(data.routeDate).format('YYYY-MM-DD');

		this.BranchService.validateRouteCheckIn(data.routeId, formattedDate, this.model.branch, this.model.loggedInUser.id)
			.then(() => {
				this.verifyVaultClose(this.model.vaultDate);
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.Modal.errorModal('error.' + err.data.message);
				}
			})
	}

	goToRouteTab(data) {
		this.Navigation.goToRouteTab(data.routeId, data.routeDate, true, null);
	}

	goToFinalResidualCount(data) {
		// this.$rootScope.$broadcast('routeChange', null);
		const obj = {
			fundingSourceLocation: data.destinationLocationId,
			isRedirected: true
		}
		this.DataCounter.setData(obj);
		this.$state.go('branchManagement.finalResidualCountCommit')
	}

	capitalizeFirstLetter(name) {
		if (typeof name !== 'string') return;
		else return name.charAt(0).toUpperCase() + name.slice(1);
	}

	goToItemTab() {
		this.$state.go('items.all', {
			page: 1
		});
	}

	goToATMCountTab() {		
		this.$state.go('atmCount');
	}

	cancelShipmentTransfer(data) {
		const shipments = [{
			shipmentId: data.shipmentId,
			trackingId: data.trackingId,
			fromLocationId: data.originLocationId,
			toLocationId: data.destinationLocationId,
			routeId: data.routeId,
			branchId: this.model.branch,
			vaultDate: moment.utc(data.routeDate).format('YYYY-MM-DD')
		}]

		this.isCancelTransferLoading = true;
		this.BranchService.cancelShipmentTransfer(shipments, 'single', this.model.branch)
			.then(() => {
				this.verifyVaultClose(this.model.vaultDate);
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.Modal.errorModal('error.' + err.data.message);
				}
			})
			.finally(() => {
				this.isCancelTransferLoading = false;
			})
	}

	goToPhysicalCashCount(data) {
		this.$state.go('branchManagement.physicalCashCount');
	}
}

export default VaultCloseController;



// WEBPACK FOOTER //
// ./client/app/components/vault_close/vault_close.controller.js